// extracted by mini-css-extract-plugin
module.exports = {"anchor":"blokwrap_anchor__055ZI"};